import styled, { keyframes } from 'styled-components';

const ACTIVITY_INDICATOR_HEIGHT = 2;
const ACTIVITY_INDICATOR_WIDTH = '105%';

export const BackgroundBar = styled.div`
    height: ${ACTIVITY_INDICATOR_HEIGHT}px;
    width: ${ACTIVITY_INDICATOR_WIDTH};
    background-color: ${({ theme }) => theme.Surface.border};
    border-radius: 2px;
    overflow: hidden;
`;

// so this will work to essentially add a delay between animations. The animation reaches its end - where the indicator
// bar is to the right of the background div - and then sits there for 80% of the animation, before going back to the
// beginning. So for a 5s animation, the indicator bar will appear to swipe across the background bar for 1s and then
// sit on the right side of the background for 4s.
const IndicatorBarAnimation = keyframes`
    0% {
        left: -${ACTIVITY_INDICATOR_WIDTH};
    }
    
    20%, 100% {
        left: ${ACTIVITY_INDICATOR_WIDTH};
    }
`;

export const IndicatorBar = styled.div<{ $indicatorColor?: string }>`
    position: relative;
    height: ${ACTIVITY_INDICATOR_HEIGHT}px;
    width: ${ACTIVITY_INDICATOR_WIDTH};
    background-color: ${({ theme, $indicatorColor }) => $indicatorColor || theme.Text.primary};
    animation: ${IndicatorBarAnimation} 5s linear infinite;
    border-radius: 2px;
`;
